import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const s = {
  page: { minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', gap: '3rem' },
  title: { fontSize: 'clamp(3rem, 8vw, 7rem)', color: 'var(--blue)', textShadow: '0 0 30px rgba(0,212,255,0.5), 4px 4px 0 rgba(0,0,0,0.5)', textAlign: 'center', lineHeight: 1, fontFamily: 'Bangers, cursive', letterSpacing: '6px' },
  cards: { display: 'flex', gap: '2rem', flexWrap: 'wrap', justifyContent: 'center' },
  card: (color, hovered) => ({ background: hovered ? color+'20' : 'rgba(13,27,42,0.8)', border: '2px solid '+(hovered ? color : color+'50'), borderRadius: '24px', padding: '2.5rem 2rem', width: '320px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5rem', cursor: 'pointer', transition: 'all 0.2s ease', boxShadow: hovered ? '0 0 40px '+color+'40, inset 0 0 20px '+color+'10' : '0 4px 20px rgba(0,0,0,0.3)', transform: hovered ? 'scale(1.03) translateY(-4px)' : 'scale(1)' }),
  emoji: { fontSize: '5rem', lineHeight: 1 },
  name: (color) => ({ fontSize: '3.5rem', color, textShadow: '0 0 20px '+color+'80', fontFamily: 'Bangers, cursive', letterSpacing: '3px' }),
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.75rem', width: '100%' },
  badge: (color) => ({ background: 'rgba(0,0,0,0.3)', border: '1px solid '+color+'40', borderRadius: '12px', padding: '1rem 0.5rem', textAlign: 'center', fontSize: '0.8rem', fontWeight: 700, color: 'var(--text-muted)' }),
  badgeEmoji: { fontSize: '2rem', display: 'block', marginBottom: '0.25rem' },
  badgeVal: (color) => ({ display: 'block', fontSize: '1.4rem', fontWeight: 900, color, textShadow: '0 0 10px '+color+'60' }),
};

const SUBJECTS = [
  { key: 'matematik', emoji: '🔢' },
  { key: 'dansk', emoji: '📝' },
  { key: 'geografi', emoji: '🌍' },
];

function UserCard({ user, name, color, emoji }) {
  const navigate = useNavigate();
  const [xp, setXp] = useState(null);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    fetch('/api/xp/'+user).then(r => r.json()).then(setXp).catch(() => {});
  }, [user]);

  return (
    <div
      style={s.card(color, hovered)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => navigate('/'+user)}
    >
      <div style={s.emoji}>{emoji}</div>
      <div style={s.name(color)}>{name}</div>
      <div style={s.grid}>
        {SUBJECTS.map(sub => (
          <div key={sub.key} style={s.badge(color)}>
            <span style={s.badgeEmoji}>{sub.emoji}</span>
            <span style={s.badgeVal(color)}>{xp ? (xp[sub.key] ? xp[sub.key].year : 0) : '…'}</span>
            XP i år
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Home() {
  return (
    <div style={s.page}>
      <h1 style={s.title}>🎓 Opgaver!</h1>
      <div style={s.cards}>
        <UserCard user="nico" name="Nico" color="#f9c74f" emoji="⚡" />
        <UserCard user="carl" name="Carl" color="#00d4ff" emoji="🚀" />
      </div>
    </div>
  );
}
